import useProjectPinningMutation from './useProjectPinningMutation';

const usePinProjectMutation = ( projectID: number ) => useProjectPinningMutation( projectID, 'pin' );

export default usePinProjectMutation;
